import classNames from 'classnames'

import './Form.scss'

interface FormFieldsProps {
  className?: string
  children?: React.ReactNode
}

export const FormFields: React.FC<FormFieldsProps> = ({
  className,
  children,
}) => {
  return <div className={classNames('form-fields', className)}>{children}</div>
}
